import { useState } from "react";
import { Button } from "V2.0/common/button";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import {
  apiBaseUrl,
  audioAcknowledgementMessage,
  documentAcknowledgementMessage,
  imageAcknowledgementMessage,
  mcubeApiKey,
  phoneNumbers,
} from "./Form/template";
import { schema } from "./Form/schema";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

const template = [
  mcubeApiKey,
  apiBaseUrl,
  phoneNumbers,
  audioAcknowledgementMessage,
  imageAcknowledgementMessage,
  documentAcknowledgementMessage,
];

export default MCubeEngageEditConfiguration;

function MCubeEngageEditConfiguration(props) {
  const { configuration, onClose, onUpdateConfiguration } = props;

  const [loading, setLoading] = useState(false);

  const inputField = {
    mcubeApiKey: configuration.mcubeApiKey,
    apiBaseUrl: configuration.apiBaseUrl,
    phoneNumbers: configuration.phoneNumbers,
    audioAcknowledgmentMessage: configuration.audioAcknowledgmentMessage,
    documentAcknowledgmentMessage:
      configuration.documentAcknowledgmentMessage,
    imageAcknowledgmentMessage: configuration.imageAcknowledgmentMessage,
  };

  const { data, error, setError, handleChange, validate } = useForm(
    inputField,
    schema,
  );

  async function handleSaveConfiguration() {
    const errors = validate(data, schema);

    if (errors) {
      setError(errors);
      return;
    }

    function init() {
      setLoading(true);
      message.loading("Saving Configuration");
    }

    function success() {
      setLoading(false);
      message.destroy();
      message.success("Configuration Saved");
    }

    function error(e) {
      setLoading(false);
      message.destroy();
      showErrorToast(e, "Failed to save configuration");
    }

    onUpdateConfiguration(data, { init, success, error });
  }

  const isSaveDisabled = loading || Object.keys(error).length > 0;

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>Edit Mcube Engage Configuration</DialogTitle>
      <DialogBody>
        <Form
          data={data}
          error={error}
          handleChange={handleChange}
          template={template}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          loading={loading}
          disabled={isSaveDisabled}
          onClick={handleSaveConfiguration}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
